<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN SCREEN -->
<div class="card" *ngIf="translations && globalUserPreferences?.storeId != null">

    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>

            <button pButton pRipple type="button" icon="pi pi-plus" pTooltip="Nuevo Registro"
                class="p-button-raised p-m-2 z-5" (click)="redirectoToReceivePayable()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <!-- LANGUAGE FORM -->
                <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">

                    <!-- INPUT COORDINACIÓN ID -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_coordination}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedCoordination')?.value}}</span>
                    </div>

                    <!-- <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_language}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedLanguage')?.value?.value}}</span>
                    </div> -->

                    <!-- INPUT PERIOD -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_period}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedPeriod')?.value?.descrip}}</span>
                    </div>

                    <!-- INPUT CURRENCIES -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_currency}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedCurrency')?.value?.value}}</span>
                    </div>

                    <!-- INPUT COORDINACIÓN ID -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1" *ngIf="activeTabPanel === 2">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>Ingrese saldo Anterior</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <input type="text" pInputText formControlName="selectedLastAmount" (blur)="updateAmount()">
                        </div>
                    </div>
                </div>
            </p-panel>
        </div>
    </div>

    <br />
    <!-- TAB VIEW -->
    <p-tabView (onChange)="onTabChange($event)" *ngIf="globalUserDataForm.get('selectedTypeDescription').value != null">
        <!-- TAB PANEL FII -->
        <p-tabPanel [index]="0" [header]="getTabHeaderDIE()">
            <p-table #dt1 [value]="dataFII" [autoLayout]="true" [paginator]="true" [rows]="40"
                [showCurrentPageReport]="false" responsive="true" editMode="row">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                (click)="reloadGetListFII()"></button>

                            <!-- <button pButton pRipple type="button" icon="pi pi-plus" pTooltip="Nuevo Registro"
                                class="p-button-raised p-m-2 z-5" (click)="redirectoToReceivePayable()"></button> -->
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header">
                    <tr *ngIf="dataFII != null && dataFII.length > 0">
                        <th *ngFor="let label of dataFII[0]?.labels;"
                            [pTooltip]="label">
                            {{ label }}
                        </th>
                        <th>{{translations.lbl_actions}}</th>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-transaction>
                    <tr *ngIf="dataFII != null && dataFII.length > 0">
                        <td *ngFor="let amount of transaction.amounts" [ngClass]="{'amount' :isNumeric(amount)}">
                            {{ isNumeric(amount) ? ((amount | number: '1.2-2')) : amount }}
                        </td>
                        <td>
                            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"
                                (click)="redirectToReceivePayableSummary(transaction)"></button>
                        </td>
                    </tr>
                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns ? columns.length : 9">
                            No se encontraron registros en la consulta solicitada.
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{ translations.lbl_there_are }} {{ dataFII?.length || 0 }} {{ translations.lbl_records }}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>

        <!-- TAB PANEL Month -->
        <p-tabPanel [index]="1" [header]="getTabHeader()">
            <p-table #dt1 [value]="dataMonth" [autoLayout]="true" [paginator]="true" [rows]="40"
                [showCurrentPageReport]="false" responsive="true" editMode="row">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                (click)="reloadGetListMonth()"></button>

                            <!-- <button pButton pRipple type="button" icon="pi pi-plus" label=""
                                [pTooltip]="translations.lbl_new_record" class="p-button-raised p-m-2 z-5"
                                (click)="redirectoToReceivePayable()"></button> -->

                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header">
                    <tr *ngIf="dataMonth != null && dataMonth.length > 0">
                        <th *ngFor="let label of dataMonth[0]?.labels" class="text-left"
                            [ngClass]="{'vertical-header': shouldApplyVerticalStyle(label), 'horizontal-header': !shouldApplyVerticalStyle(label)}"
                            [pTooltip]="label">
                            {{ label }}
                        </th>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-transaction>
                    <tr *ngIf="dataMonth != null && dataMonth.length > 0">
                        <td *ngFor="let amount of transaction.amounts" [ngClass]="{'amount' :isNumeric(amount), 'text-left' : !isNumeric(amount)}">
                            {{ isNumeric(amount) ? ((amount | number: '1.2-2')) : amount }}
                        </td>
                    </tr>
                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns ? columns.length : 9">
                            No se encontraron registros en la consulta solicitada.
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{ translations.lbl_there_are }} {{ dataMonth?.length || 0 }} {{ translations.lbl_records }}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>

        <!-- TAB PANEL Bank -->
        <p-tabPanel [index]="2" header="Conciliación Banco"
            *ngIf="dataParent?.conType && dataParent.conType === 'I' && dataParent.month === '01'">
            <p-table #dt1 [value]="dataBank" [autoLayout]="true" [paginator]="true" [rows]="40"
                [showCurrentPageReport]="false" responsive="true" editMode="row">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                (click)="reloadGetListBank()"></button>

                            <button pButton pRipple type="button" icon="pi pi-save" [pTooltip]="translations.lbl_update"
                                class="p-button-success p-m-2 z-5" (click)="updateAmount()"></button>
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header" let-columns>
                    <tr *ngIf="dataBank != null && dataBank.length > 0">
                        <th class="text-left">Descripción</th>
                        <th class="amount">Cantidad ({{globalUserDataForm.get('selectedCurrency')?.value?.valueId}})</th>

                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pEditableRow]="rowData" *ngIf="dataBank != null && dataBank.length > 0">

                        <td class="text-left" style="white-space: normal; word-wrap: break-word;">
                            <mark [ngStyle]="{ 'background-color': rowData?.itemColor != null ? rowData?.itemColor : 'transparent',
                   'font-weight': rowData?.bold != null && rowData.bold ? 'bold' : 'normal' }">
                                {{ rowData?.descrip ? rowData.descrip : 'S/N' }}
                            </mark>

                        </td>

                        <td class="amount">
                            {{ isNumeric(rowData.amount) ? ((rowData.amount | number: '1.2-2')) : '0.00' }}
                        </td>
                    </tr>
                </ng-template>


                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns ? columns.length : 9">
                            No se encontraron registros en la consulta solicitada.
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{ translations.lbl_there_are }} {{ dataBank?.length || 0 }} {{ translations.lbl_records }}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>

    </p-tabView>
</div>

<!-- OVERLAY SCREEN NO STORE ID -->
<div *ngIf="globalUserPreferences?.storeId == null" class=" overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Verifica sesión e intenta mas tarde ... </span>
</div>